module.exports = "section.course-enrollment-component ::ng-deep .standard-grid .dx-datagrid-nodata {\n  color: #495665 !important; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/distributor/components/course-enrollment/course-enrollment.component.scss
// module id = ./src/app/distributor/components/course-enrollment/course-enrollment.component.scss
// module chunks = main